/**
 * The in-app "refetch your signals" event (SIG-08). Web push (`webPush.ts`) and the SW-message bridge
 * dispatch it; every mounted `DaySignals` listens and refetches. Kept in its own tiny module so the
 * feed component doesn't pull in the Firebase-messaging import chain.
 */
export const SIGNAL_WAKE_EVENT = 'lapo:signals-wake';

export interface SignalWakeDetail {
  /** The woken journal note id (`journal-YYYY-MM-DD`), if the push carried one. */
  noteId?: string;
  /** The affected day, parsed from `noteId`; when absent, every day refetches. */
  dateKey?: string;
}

/** Fire the wake event so open `DaySignals` refetch (optionally scoped to one day via `noteId`). */
export function dispatchSignalWake(noteId?: string): void {
  const dateKey = noteId && noteId.startsWith('journal-') ? noteId.slice('journal-'.length) : undefined;
  const detail: SignalWakeDetail = { noteId, dateKey };
  window.dispatchEvent(new CustomEvent(SIGNAL_WAKE_EVENT, { detail }));
}
